import { useQueryClient } from '@tanstack/react-query';

import { SIMULATION_STATUS_KEY } from '../config';

export const useInvalidateSimulationStatus = () => {
  const queryClient = useQueryClient();

  return () =>
    queryClient.invalidateQueries({
      queryKey: [SIMULATION_STATUS_KEY],
    });
};
